<div class="row">
  <div class="col-6" *ngFor="let item of items">
    <app-project-activity-card [cardInfo]="item" (selectionChange)="selectCard($event)"></app-project-activity-card>
  </div>
</div>
